export { browser as default } from '@src/app/browser';
